import UpdateCampaignPartial from "../../partials/campaign/update-campaign.partial";

export default function UpdateCampaignScreen() {
  return <UpdateCampaignPartial />;
}
